import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

const initialState: any = {
  poisStore: [],
  pointSalePois: [],
  emtOfficePois: [],
};

export const poisSlices = createSlice({
  name: 'poisSlices',
  initialState,
  reducers: {
    updatePois: (state, action) => {
      state.poisStore = action.payload;
    },
    updatePointsSalePois: (state, action) => {
      state.pointSalePois = action.payload;
    },
    updateEmtOfficePois: (state, action) => {
      state.emtOfficePois = action.payload;
    },
  },
});

export const { updatePois, updatePointsSalePois, updateEmtOfficePois } = poisSlices.actions;

export const poisState = (state: RootState) => state.pois.poisStore;
export const pointSalePoisState = (state: RootState) => state.pois.pointSalePois;
export const emtOfficePoisState = (state: RootState) => state.pois.emtOfficePois;

export default poisSlices.reducer;
